import { useEffect, useState } from 'react'

import { ConfirmSubmitModal } from '@/components/shared/modal'

type Props = {
  url: string
  opened: boolean
  onClose: () => void
  closeButtonText?: string
  submitButtonText?: string
}

export const RedirectModal = ({
  url,
  opened,
  onClose,
  closeButtonText = 'Вернуться',
  submitButtonText = 'Перейти'
}: Props) => {
  const [isDismissed, setIsDismissed] = useState(false)

  useEffect(() => {
    if (opened) {
      setIsDismissed(false)
    }
  }, [opened])

  if (!opened || isDismissed) {
    return null
  }

  const handleSubmit = () => {
    setIsDismissed(true)
    onClose()
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  return (
    <ConfirmSubmitModal
      noBackdrop
      header="Переход по ссылке"
      opened
      onClose={onClose}
      message={
        <p className="text-grey-70 text-20">
          Вы переходите по ссылке –{' '}
          <span
            data-testid="redirect-modal-url-id"
            className="break-words text-bronze-40 underline"
          >
            {url}
          </span>
          {', которая ведёт за пределы личного кабинета'}
        </p>
      }
      closeButtonText={closeButtonText}
      submitButtonText={submitButtonText}
      onSubmit={handleSubmit}
    />
  )
}
